import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  success: false,
  myBetData: [],
  betListData: [],
  cashAmount: [],
  cashAmountLoading: false,
  error: false,
  CashOutLoading: false,
  cashOutData: [],
  sportStatisticsLoading: false,
  sportStatisticsData: [],
  feedProvider: "",
  cashoutAmountBetSlipId: ""
};

const myBets = createSlice({
  name: "myBets",
  initialState,
  reducers: {
    getMyBetsStart: (state, action) => {
      state.loading = true;
    },
    getMyBetsSuccess: (state, action) => {
      state.myBetData = action.payload;
      state.loading = false;
      state.success = true;
    },
    getMyBetsFailure: (state, action) => {
      state.loading = false;
      state.error = true;
    },
    getBetListStart: (state, action) => {
      state.betListLoading = true;
    },
    getBetListSuccess: (state, action) => {
      state.betListLoading = false;
      state.betListData = action.payload;
    },
    getBetListFailure: (state, action) => {
      state.betListLoading = false;
    },
    getCashoutAmountStart: (state, action) => {
      state.cashAmountLoading = true;
      state.cashoutAmountBetSlipId = action.payload?.betslipId;
      state.cashOutData = initialState.cashOutData;
    },
    getCashoutAmountSuccess: (state, action) => {
      state.cashAmountLoading = false;
      state.cashAmount = action.payload?.payoutValue;
      state.feedProvider = action.payload?.feedProvider;
    },
    getCashoutAmountFailure: (state, action) => {
      state.cashAmountLoading = false;
      state.cashAmount = null;
    },
    getCashOutStart: (state, action) => {
      state.CashOutLoading = true;
    },
    getCashOutSuccess: (state, action) => {
      state.CashOutLoading = false;
      if (action?.payload?.cashOut) {
        state.cashOutData = action.payload;
      } else {
        state.cashAmount = action.payload?.payoutValue;
      }
    },
    getCashOutFailure: (state, action) => {
      state.CashOutLoading = false;
    },
    getSportStatisticsStart: (state, action) => {
      state.sportStatisticsLoading = true;
    },
    getSportStatisticsSuccess: (state, action) => {
      state.sportStatisticsLoading = false;
      state.sportStatisticsData = action.payload;
    },
    getSportStatisticsFailure: (state, action) => {
      state.sportStatisticsLoading = false;
    },
    resetCashout: (state) => {
      state.cashAmount = "";
      state.cashAmountLoading = false;
      state.cashOutData = initialState.cashOutData;
      state.feedProvider = "";
    }
  }
});

export const {
  resetCashout,
  getMyBetsStart,
  getMyBetsSuccess,
  getMyBetsFailure,
  getBetListStart,
  getBetListSuccess,
  getBetListFailure,
  getCashoutAmountStart,
  getCashoutAmountSuccess,
  getCashoutAmountFailure,
  getCashOutStart,
  getCashOutSuccess,
  getCashOutFailure,
  getSportStatisticsStart,
  getSportStatisticsSuccess,
  getSportStatisticsFailure
} = myBets.actions;

export default myBets.reducer;
